module.exports = __webpack_public_path__ + "static/media/10.cd1b51bb.webp";